import {
    GET_SALES_REPORT_ORDER_COLUMN_REQUEST,
    GET_SALES_REPORT_ORDER_COLUMN_SUCCESS,
    GET_SALES_REPORT_ORDER_COLUMN_ERROR,
    } from "../actions/types";


export const salesReportOrderColumn = (state = [], action) => {
    const { type, payload } = action;
    switch (type) {
      case GET_SALES_REPORT_ORDER_COLUMN_REQUEST:
        return {
          loading: true,
        };
      case GET_SALES_REPORT_ORDER_COLUMN_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case GET_SALES_REPORT_ORDER_COLUMN_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };
  
      default: {
        return state;
      }
    }
  };